import React from 'react';
import { PropTypes } from 'prop-types';
import { Icon } from '@unite-us/ui';
import cx from 'classnames';
var ExpandableButton = function ExpandableButton(_ref) {
  var isOpen = _ref.isOpen,
    onClick = _ref.onClick,
    dataTestId = _ref.dataTestId,
    className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onClick,
    className: cx('flex items-center focus:outline-none z-0', className),
    "data-testid": dataTestId
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-action-blue font-bold cursor-pointer"
  }, children || (isOpen ? 'Hide' : 'Show')), /*#__PURE__*/React.createElement(Icon, {
    "aria-hidden": true,
    className: cx('transition-transform duration-500 ease-in-out ml-2 cursor-pointer', isOpen && 'transform rotate-180'),
    icon: "IconChevronDown",
    size: 12
  }));
};
ExpandableButton.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  dataTestId: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node
};
ExpandableButton.defaultProps = {
  className: '',
  children: null
};
export default ExpandableButton;
//# sourceMappingURL=ExpandableButton.js.map